import AOS from "aos";
AOS.init();
window.addEventListener("load", AOS.refresh);
